import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Sparkles } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const POLL_INTERVAL = 60000;

export default function UpdatesButton() {
  const navigate = useNavigate();
  const [hasNew, setHasNew] = useState(false);

  useEffect(() => {
    let alive = true;
    const load = () => {
      axios
        .get(`${API}/api/updates/has-new`, { withCredentials: true })
        .then(({ data }) => { if (alive) setHasNew(!!data.has_new); })
        .catch(() => {});
    };
    load();
    const id = setInterval(load, POLL_INTERVAL);
    return () => { alive = false; clearInterval(id); };
  }, []);

  const onClick = () => {
    setHasNew(false);
    navigate("/nouveautes");
  };

  return (
    <button
      data-testid="updates-button"
      onClick={onClick}
      className="relative w-10 h-10 flex items-center justify-center rounded-lg border border-white/10 hover:border-gold/30 hover:bg-white/5 transition-all"
      style={{ backgroundColor: "rgba(11,24,54,0.85)", backdropFilter: "blur(8px)" }}
      aria-label="Nouveautés"
      title="Nouveautés"
    >
      <Sparkles size={18} className="text-cbm-secondary" />
      {hasNew && (
        <span
          data-testid="updates-badge-dot"
          className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-red-500 border-2"
          style={{ borderColor: "#071028" }}
        />
      )}
    </button>
  );
}
